/**
  * this create remove Lightbox hideItem effect
**/
import $ from 'jquery';

export	function removeLightBoxHideItem(){

	 $(".js-lbImage").on("click", function(){
                        $("#miniLB__fixture > #miniLB__popup > .js-lightboxContent > .js-lightboxImage").removeClass("hideItem");
         });

		
}
